import { useCallback, useContext } from 'react';
import { PortalsContext } from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/PortalsProvider';
import { UIVersionContext } from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';
import {
  buildDashboardShow,
  buildReportShow,
  buildShowBoard,
  buildShowGlobalGoal,
  buildShowGlobalKpiList,
  buildShowPerformanceApp,
  buildShowTargetApp,
  buildShowWorkSpace,
} from 'navigation/appRoutes';

const useContentLink = () => {
  const { isV3 } = useContext(UIVersionContext);
  const { selectedPortal } = useContext(PortalsContext);

  const buildContentItemLink = useCallback(
    (contentItem: ContentIndexTypes.ContentItem): string => {
      if (isV3) {
        return `/content/${contentItem.key}`;
      }

      const portal = selectedPortal;
      switch (contentItem.type) {
        case 'dashboard':
          return buildDashboardShow({ id: contentItem.key, portal });
        case 'report':
          return buildReportShow({ id: contentItem.key, portal });
        case 'scorecard':
          return buildShowGlobalKpiList({
            scorecardId: contentItem.key,
            portal,
          });
        case 'goal':
          return buildShowGlobalGoal(contentItem.key);
        case 'board':
          return buildShowBoard(contentItem.key);
      }
    },
    [isV3, selectedPortal],
  );

  // Mirrors buildLink in screens/LegacyHome/RecentsCard
  const buildLegacyWorkSpaceLink = useCallback(
    (workSpace: WorkSpace | TargetsApp.App): string => {
      if (workSpace.campaignType === 'targetsApp') {
        return buildShowTargetApp(workSpace.id, selectedPortal);
      }
      if (workSpace.campaignType !== 'general') {
        return buildShowPerformanceApp(workSpace.id, selectedPortal);
      }
      return buildShowWorkSpace(workSpace.id);
    },
    [selectedPortal],
  );

  const buildV3WorkspaceLink = useCallback(
    (workspace: V3.Workspace) => `/workspaces/${workspace.urlSlug}`,
    [],
  );

  const buildV3ProductLink = useCallback(
    (product: V3.Product) => `/apps/${product.urlSlug}`,
    [],
  );

  return {
    buildContentItemLink,
    buildLegacyWorkSpaceLink,
    buildV3WorkspaceLink,
    buildV3ProductLink,
  };
};

export default useContentLink;
